import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontSize: 10,
  },
  title: {
    fontSize: 18,
    marginBottom: 10,
    textAlign: 'center',
  },
  table: {
    display: 'table',
    width: 'auto',
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableHeader: {
    backgroundColor: '#eeeeee',
    borderBottomWidth: 1,
    borderBottomColor: '#000',
    fontWeight: 'bold',
  },
  tableCell: {
    margin: 2,
    padding: 4,
    fontSize: 10,
    width: '20%',
    borderStyle: 'solid',
    borderWidth: 0.5,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  pageBreak: {
    pageBreak: 'always',
  },
});

const LectureReportpdf = ({ data }) => {
  const rowsPerPage = 30; // tweak as needed for fit

  // Split data into chunks per page
  const chunkedData = [];
  for (let i = 0; i < data.length; i += rowsPerPage) {
    chunkedData.push(data.slice(i, i + rowsPerPage));
  }

  return (
    <Document>
      {chunkedData.map((pageRows, pageIndex) => (
        <Page size="A4" style={styles.page} key={pageIndex}>
          <Text style={styles.title}>Lecture Report</Text>

          {/* Sticky-like Header on every page */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={styles.tableCell}>Lecture</Text>
            <Text style={styles.tableCell}>Faculty</Text>
            <Text style={styles.tableCell}>Topic</Text>
            <Text style={styles.tableCell}>Start</Text>
            <Text style={styles.tableCell}>End</Text>
          </View>

          {pageRows.map((item, i) => (
            <View style={styles.tableRow} key={i}>
              <Text style={styles.tableCell}>{item.Lecture_Name}</Text>
              <Text style={styles.tableCell}>{item.Faculty_Name}</Text>
              <Text style={styles.tableCell}>{item.Topic}</Text>
              <Text style={styles.tableCell}>{item.Lecture_Start}</Text>
              <Text style={styles.tableCell}>{item.Lecture_End}</Text>
            </View>
          ))}
        </Page>
      ))}
    </Document>
  );
};

export default LectureReportpdf;